/**
 * Application configuration
 */

// Automatically detect if we're in production or development based on domain
const isProduction = window.location.hostname === 'easyhealthdigital.com' || window.location.hostname === 'www.easyhealthdigital.com';
const isDevelopment = window.location.hostname === 'dev.easyhealthdigital.com' || window.location.hostname === 'www.dev.easyhealthdigital.com';

// Debug logging
console.log('🔧 Frontend Config Debug:');
console.log('Current hostname:', window.location.hostname);
console.log('isProduction:', isProduction);
console.log('isDevelopment:', isDevelopment);

// Replace YOUR_LOCAL_IP with your actual IP (e.g., 192.168.1.100)
const LOCAL_IP = 'localhost';

export const config = {
  debugOtp: false,
  mapsApiKey: 'AIzaSyA6xFjorrByqcT7crcd17DwnTLR8GoR5ac',
  // Backend configuration
  backend: {
    // Backend host with port - automatically detect based on current domain
    host: isProduction 
      ? 'https://easyhealthdigital.com'
      : isDevelopment
      ? 'https://dev.easyhealthdigital.com'
      : `http://${LOCAL_IP}:8000`,
    
    // WebSocket configurations
    ws: {
      // WebSocket host with port - automatically detect based on current domain
      host: isProduction
        ? window.location.host
        : isDevelopment
        ? 'dev.easyhealthdigital.com'
        : `${LOCAL_IP}:8000`,
      
      // WebSocket endpoints
      endpoints: {
        admin: '/ws/admin/notifications',
        bda: '/ws/bda/notifications',
        patient: '/ws/patient/notifications'
      }
    }
  }
};

// Debug the final config
console.log('🎯 Final API Host:', config.backend.host);
console.log('🎯 Final WebSocket Host:', config.backend.ws.host);

export default config; 

